'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

var _times = require('HubStyleTokens/times');

var _TwoWayTransition = require('../transitions/TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _UILayer = require('../layer/UILayer');

var _UILayer2 = _interopRequireDefault(_UILayer);

var _memoizeOne = require('react-utils/memoizeOne');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getTransitionProps = function getTransitionProps(animateOnMount) {
  return {
    transitionOnMount: animateOnMount
  };
};

var transitionTime = parseInt(_times.SLIDEIN_MODAL_TRANSITION_TIMING, 10);

var StickyFooter = (0, _styledComponents2.default)(function (props) {
  var __sandboxed = props.sandboxed,
      rest = _objectWithoutProperties(props, ['sandboxed']);

  return _react2.default.createElement('div', rest);
}).withConfig({
  displayName: 'UIStickyFooter__StickyFooter'
})(['background:', ';border-top:1px solid ', ';bottom:0;left:0;position:', ';right:0;z-index:', ';'], _colors.OLAF, _colors.KOALA, function (_ref) {
  var sandboxed = _ref.sandboxed;
  return sandboxed ? 'absolute' : 'fixed';
}, _sizes.JUPITER_LAYER);

var StickyFooterTransitionWrapper = (0, _styledComponents2.default)(function (props) {
  var hidden = props.hidden,
      transitioning = props.transitioning,
      rest = _objectWithoutProperties(props, ['hidden', 'transitioning']);

  return _react2.default.createElement(_TwoWayTransition2.default.PlainWrapper, _extends({
    'data-component-name': 'UIStickyFooter',
    'data-open-complete': !hidden && !transitioning
  }, rest));
}).withConfig({
  displayName: 'UIStickyFooter__StickyFooterTransitionWrapper'
})(['', '{transition-property:', ';transition-duration:', 'ms;transform:', ';}'], StickyFooter, function (_ref2) {
  var transitionActive = _ref2.transitionActive;
  return transitionActive ? 'transform' : 'none';
}, transitionTime, function (_ref3) {
  var hidden = _ref3.hidden;
  return 'translateY(' + (hidden ? '100' : '0') + '%)';
});

var StickyFooterTransition = function (_React$Component) {
  _inherits(StickyFooterTransition, _React$Component);

  function StickyFooterTransition() {
    _classCallCheck(this, StickyFooterTransition);

    return _possibleConstructorReturn(this, (StickyFooterTransition.__proto__ || Object.getPrototypeOf(StickyFooterTransition)).apply(this, arguments));
  }

  _createClass(StickyFooterTransition, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_TwoWayTransition2.default, _extends({}, this.props, {
        duration: transitionTime,
        Wrapper: StickyFooterTransitionWrapper
      }));
    }
  }]);

  return StickyFooterTransition;
}(_react2.default.Component);

var UIStickyFooter = function (_PureComponent) {
  _inherits(UIStickyFooter, _PureComponent);

  function UIStickyFooter(props) {
    _classCallCheck(this, UIStickyFooter);

    var _this2 = _possibleConstructorReturn(this, (UIStickyFooter.__proto__ || Object.getPrototypeOf(UIStickyFooter)).call(this, props));

    _this2._getTransitionProps = (0, _memoizeOne2.default)(getTransitionProps);
    return _this2;
  }

  _createClass(UIStickyFooter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animateOnMount = _props.animateOnMount,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['animateOnMount', 'className']);

      var sandboxed = this.context.sandboxed;


      var renderedFooter = _react2.default.createElement(StickyFooter, _extends({}, rest, {
        className: (0, _classNames2.default)(className, 'private-sticky-footer'),
        sandboxed: sandboxed
      }));

      return sandboxed ? renderedFooter : _react2.default.createElement(
        _UILayer2.default,
        {
          'data-layer-for': 'UIStickyFooter',
          Transition: StickyFooterTransition,
          transitionProps: this._getTransitionProps(animateOnMount)
        },
        renderedFooter
      );
    }
  }]);

  return UIStickyFooter;
}(_react.PureComponent);

UIStickyFooter.propTypes = {
  animateOnMount: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node
};

UIStickyFooter.contextTypes = {
  sandboxed: _react.PropTypes.bool
};

UIStickyFooter.defaultProps = {
  animateOnMount: true
};

UIStickyFooter.displayName = 'UIStickyFooter';

exports.default = UIStickyFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/panel/UIStickyFooter.js
// module id = 571
// module chunks = 171